import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

type ImageGalleryProps = {
  images: string[];
  onSlideChange?: (slide: number) => void;
  initial?: number;
};

export const ImageGallery: React.FC<ImageGalleryProps> = ({ images, initial = 0, onSlideChange }) => {
  return (
    <Swiper
      slidesPerView={1}
      onSlideChange={(swiper) => {
        if (onSlideChange) onSlideChange(swiper.activeIndex);
      }}
      initialSlide={initial}>
      {images.map((image, i) => {
        return (
          <SwiperSlide key={`slide-${i}`} style={{ alignSelf: 'center', display: 'flex' }}>
            <img style={{ objectFit: 'contain', width: '100%' }} src={image}></img>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};
